module.exports = __webpack_public_path__ + "img/face-circle.ef9aec5f.png";